import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const HBO = () => (
  <div>
    <h2>HBO</h2>
    <p>6 Channels of Premium HBO Content in HD. $19</p>
    <Button outline color="success" id="hbotoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#hbotoggle">
      <Card>
        <CardBody>
          400 - HBO<br />
          401 - HBO2<br />
          402 - HBO Comedy<br />
          403 - HBO Family<br />
          404 - HBO Signature<br />
          405 - HBO Zone<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default HBO;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/hbo.js